<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Dashboard Filters</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content pt-4 pb-1 px-3">
    <div class="row" *ngIf="canSelectSites">
      <div class="col">
        <div class="d-flex justify-content-center" style="padding: 5px !important;">
          <button mat-raised-button color="secondary" type="button" class="full-width mb-4" style="max-width: 150px" (click)="onSelectSites()" [matBadge]="'' + (filter_options.site_ids && filter_options.site_ids.length ? filter_options.site_ids.length : '')" matTooltip="Select from a list of {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() }} in your account.">{{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-center" style="padding: 0 1px !important;">
          <app-date-range-picker dateRangeTitle="Select Date Range" dateRangePlaceholder="Select Date Range" dateRangeTooltip="Filter stats by date range." [dateRangeInput]="filter_options.date_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
        </div>
      </div>
    </div>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
      <mat-icon>filter_list</mat-icon> Apply Filter
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
      <mat-icon> clear_all</mat-icon> Clear Filter
    </button>
  </div>
  <div class="p-2" *ngIf="filter_options.date_range.length == 2">
    <button
      type="button"
      mat-raised-button
      color="secondary"
      (click)="onClearDateRange()">
      <mat-icon>clear</mat-icon> Clear Date Range
    </button>
  </div>
</mat-dialog-actions>
